import request from '@/utils/request'

export function getAFCloudList(params){
  return request({
    url: `/afsassauth/${params}`,
    method:'GET'
  })
}
export function getAFCloudApps(){
  return request({
    url: `/afsassauth/apps/`,
    method:'GET'
  })
}

export function getAFOrdersModules(id){
  return request({
    url: `/afsassauth/${id}/orders_modules/`,
    method:'GET'
  })
}


// 试用
export function trailAFCloud(data){
  return request({
    url: '/afsassauth/trail_app/',
    method:'POST',
    data
  })
}
export function AFCloudAdminDelay(id,data){
    return request({
      url: `/afsassauth/${id}/admin_delay_app/`,
      method:'POST',
      data
    })
  }

export function queryOrgs(data){
  return request({
    url: '/afsassauth/query_orgs/',
    method:'POST',
    data
  })
}

export function buyAFCloudPrice(data){
  return request({
    url: '/afsassauth/buy_price/',
    method:'POST',
    data
  })
}

export function buyAFCloudPackagePrice(data){
  return request({
    url: '/afsassauth/buy_package/',
    method:'POST',
    data
  })
}

export function buyAFCloud(data){
  return request({
    url: '/afsassauth/buy_app/',
    method:'POST',
    data
  })
}


export function updateAFCloud(id, data){
  return request({
    url: `/afsassauth/${id}/`,
    method:'PATCH',
    data
  })
}

// 流量包
export function getPackageBuyApp(data){
  return request({
    url: '/afsassauth/packages/',
    method:'POST',
    data
  })
}

// 产品年度


export function getPeriodsBuyApp(data){
  return request({
    url: '/afsassauth/valid_periods/',
    method:'POST',
    data
  })
}


export function AFCloudTransfer(id,data){
  return request({
    url: `/afsassauth/${id}/transfer/`,
    method:'POST',
    data
  })
}

// buyAFCloudPrice





// WEBPACK FOOTER //
// ./src/api/afCloud.js